module.exports = __webpack_public_path__ + "img/rosepetal-dep-inserma.d797c38a.jpg";